const hotels = {
  accommodation: "Accommodation",
  hotel: "Hotel",
  hotels: "Hotels",
  back: "Back",
  rooms: "Rooms",
  viewPictures: "View Pictures",
  showMore: "show more",
  bookingInformation: "Booking Information",
  importantInformation: "Important Information",
  cancellationPolicy: "Cancellation Policy",
  from: "From",
  to: "Προς την",
  cancellationIs: "cancellation is",
  free: "free",
  chargeableWithFeeOf: "chargeable with a fee of",
  prebook: "Prebook",
  guests: "Guests",
  payment: "Payment",
  byClicking: "By clicking",
  next: "Next",
  youAreAgreeingToOur: "you are agreeing to our",
  termsAndConditions: "Terms and Conditions",
  previous: "Previous",
  cancel: "Cancel",
  mealPlan: "Meal Plan",
  roomType: "Room Type",
  description: "Description",
  readLess: "Read Less",
  readMore: "Read More",
  facilities: "Facilities",
  viewLess: "View Less",
  viewMore: "View More",
  less: "less",
  more: "more",
  notAvailable_short: "N/A",
  backToHotelList: "Back to hotel list",
  viewOnMap: "View on map",
  sleeps: "Sleeps",
  adults: "Adults",
  yearsOld: "years old",
  type: "Type",
  bedding: "Bedding",
  selectRoom: "Select Room",
  selectRooms: "Select Rooms",
  city: "City",
  checkIn: "Check In",
  checkOut: "Check Out",
  date: "Date",
  dates: "Dates",
  persons: "Persons",
  stillOnTrialQuestionToUpgrade:
    "Oops! Looks like you’re still on a trial membership. You need to be a confirmed member to make bookings. Would you like to upgrade now?",
  stillOnTrialQuestionToUpgradeNonElligib:
    "Oops! Looks like you aren't subscribed yet. You need to be a confirmed member to make bookings. Would you like to upgrade now?",
  completeProfile: "Please complete your user profile first",
  upgrade: "Αναβαθμίζω",
  close: "Close",
  viewDetails: "View Details",
  name: "Name",
  rating: "Rating",
  budget: "Budget",
  orderBy: "Order By",
  priceLowestFirst: "Price (lowest first)",
  priceHighestFirst: "Price (highest first)",
  ratingLowestFirst: "Rating (lowest first)",
  ratingHighestFirst: "Rating (highest first)",
  starRatingAndPrice: "Star Rating and Price",
  biggestSavingsFirst: "Biggest Savings First",
  select: "Select",
  reset: "Reset",
  apply: "Apply",
  filterBy: "Filter by",
  myProfile: "My Profile",
  login: "Login",
  roomOnly: "Room Only",
  bedAndBreakfast: "Bed & Breakfast",
  halfBoard: "Half Board",
  fullBoard: "Full Board",
  allInclusive: "All Inclusive",
  filter: "Filter",
  mapView: "Map View",
  results: "results",
  listView: "List View",
  newSearch: "New Search",
  editSearch: "Edit Search",
  all: "All",
  multiple: "Multiple",
  editProfile: "Edit Profile",
  backToHotelsList: "Back to Hotels List",
  roomName: "Room Name",
  mealType: "Meal Type",
  freeCancellation: "Free Cancellation",
  yes: "Yes",
  no: "Οχι",
  filters: "Filters",
  cancellationNonRefundable: "Cancellation is non-refundable",
  hotelRating: "Hotel Rating",
  any: "Any",
  off: "Off",
  performNewSearch: "Perform a new search",
};

export default hotels;
